import React from "react";

type Props = {
  text: string;
  boldSubstrings: { length: number; offset: number }[];
};

const BoldSubstring = ({ text, boldSubstrings }: Props) => {
  if (!text || boldSubstrings.length === 0) {
    return <span>{text}</span>;
  }

  boldSubstrings.sort((a, b) => a.offset - b.offset);

  const sections: JSX.Element[] = [];
  let currentOffset = 0;
  for (const boldSubstring of boldSubstrings) {
    sections.push(
      <span key={`text-${boldSubstring.offset}`}>
        {text.slice(currentOffset, boldSubstring.offset)}
      </span>
    );
    sections.push(
      <strong key={`bold-${boldSubstring.offset}`}>
        {text.slice(
          boldSubstring.offset,
          boldSubstring.offset + boldSubstring.length
        )}
      </strong>
    );

    currentOffset = boldSubstring.offset + boldSubstring.length;
  }

  sections.push(<span key={`last-text`}>{text.slice(currentOffset)}</span>);

  return <>{sections}</>;
};

export default BoldSubstring;
